import React, { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";

// Alto de la barra fija (ver .barra-secciones en App.css), para que el scroll no tape el título
const ALTO_BARRAS_FIJAS = 64;

const secciones = [
  { key: "resultados", label: "Resultados", id: "resultados" },
  { key: "pilotos", label: "Pilotos", id: "pilotos" },
  { key: "calendarios", label: "Calendario", id: "calendarios" },
  { key: "reglamentos", label: "Reglamento", id: "reglamentos" },
];

// Barra con las secciones de la página y el selector de campeonato
export const NavbarSeccionesAsociacion = ({
  campeonatos = [],
  campeonatoSeleccionado,
  onCampeonatoChange,
  logo,
  nombre,
}) => {
  const [seccionActiva, setSeccionActiva] = useState("resultados");
  const [mostrarLogo, setMostrarLogo] = useState(false);

  // El logo chico aparece en la barra cuando la banda grande del logo ya salió de la pantalla
  useEffect(() => {
    const banda = document.querySelector(".banda-asoc");
    if (!banda || !("IntersectionObserver" in window)) return;
    const observador = new IntersectionObserver(
      ([entrada]) => setMostrarLogo(!entrada.isIntersecting),
      { rootMargin: `-${ALTO_BARRAS_FIJAS}px 0px 0px 0px` }
    );
    observador.observe(banda);
    return () => observador.disconnect();
  }, []);

  const irASeccion = (seccion) => {
    setSeccionActiva(seccion.key);
    const elemento = document.getElementById(seccion.id);
    if (elemento) {
      const top = elemento.getBoundingClientRect().top + window.pageYOffset - ALTO_BARRAS_FIJAS;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="barra-secciones">
      {logo && (
        <img
          src={logo}
          alt={`Logo ${nombre || "asociación"}`}
          className={`barra-secciones-logo ${mostrarLogo ? "visible" : ""}`}
        />
      )}
      <nav>
        {secciones.map((seccion) => (
          <button
            key={seccion.key}
            type="button"
            className={seccion.key === seccionActiva ? "activo" : ""}
            onClick={() => irASeccion(seccion)}
          >
            {seccion.label}
          </button>
        ))}
      </nav>

      <label className="barra-secciones-select">
        <select
          value={campeonatoSeleccionado ?? ""}
          onChange={onCampeonatoChange}
          aria-label="Campeonato"
        >
          {campeonatos.map((campeonato) => (
            <option key={campeonato.id} value={campeonato.id}>
              {campeonato.nombre_campeonato} {campeonato.año}
            </option>
          ))}
        </select>
        <DownOutlined />
      </label>
    </div>
  );
};
